import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap';
import { OrdersData } from '../../common/data/dashboard';

//import Charts
import ReactApexChart from 'react-apexcharts';

const Orders = ({ options, item }: any) => {
  const [lSeries, setlSeries] = useState([12, 5]);

  useEffect(() => {
    if (item?.series) {
      setTimeout(() => {
        setlSeries(item?.series);
      }, 0);
    }
  }, [item]);

  const renderItem = () =>
    item.labels.map((label: any, index: any) => {
      const className = `mdi mdi-circle align-middle font-size-10 me-2`;
      return (
        <div>
          <p className="mb-2" style={{ color: item?.options?.colors[index] }}>
            <i className={className}></i>
            {label}&nbsp;
          </p>
        </div>
      );
    });

  return (
    <React.Fragment>
      <Card className="card-h-100">
        <CardHeader className="align-items-center d-flex">
          <CardTitle className="mb-0 flex-grow-1">
            {
              <p style={{ color: `${item?.options?.ColorTitle || '#000000'}` }}>
                {item['title']}
              </p>
            }
          </CardTitle>
        </CardHeader>
        <CardBody className="card-body-orders">
          <Row className="align-items-center">
            <Col>
              {item.options ? (
                <ReactApexChart
                  options={item?.options}
                  series={lSeries}
                  type="donut"
                  width="140%"
                />
              ) : null}
            </Col>
            <Col>
              <div className="col-sm">
                <div className="mt-4 mt-sm-0 card-items">{renderItem()}</div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Orders;
